import type { oz } from '@weft/utils';
import { segregated } from '../../utils/segregated';
import { NewEventSchema } from './new-event-schema';

export const EventSchema = segregated(NewEventSchema);

export type Event = oz.infer<typeof EventSchema>;
